module.exports = __webpack_public_path__ + "img/hr-rock-big-16.d3bb59a3.png";